<template>
  <q-dialog
    :visible="isVisible"
    title="产品详情"
    width="950px"
    :showFooter="false"
    @close="onCancel">
    <div class="table-title">
      <span>{{productName}}</span>
      <span>{{productCode}}</span>
    </div>
    <el-table
      border
      :header-cell-style="{backgroundColor: '#F4F8FB'}"
      :data="tableData1">
      <el-table-column label="计划" prop="planNumTotal"></el-table-column>
      <el-table-column label="余备料" prop="residueNumTotal"></el-table-column>
      <el-table-column label="未排" prop="unPlanNumTotal"></el-table-column>
      <el-table-column label="排程" prop="planCount"></el-table-column>
      <el-table-column label="在制" prop="makingNumTotal"></el-table-column>
      <el-table-column :label="processLabel" prop="inStockNum"></el-table-column>
      <el-table-column label="在途" prop="passage"></el-table-column>
      <el-table-column label="物流总库存" prop="totalLogistics"></el-table-column>
      <el-table-column label="可销售库存" prop="companyAvlInventory"></el-table-column>
    </el-table>

    <div class="table-title mt10">
      产品对应包件（{{tableData2.length}}个）
    </div>
    <el-table
      border
      :header-cell-style="{backgroundColor: '#F4F8FB'}"
      :data="tableData2">
      <el-table-column label="包件编码" prop="packCode" show-overflow-tooltip></el-table-column>
      <el-table-column label="包件名称" prop="packName" show-overflow-tooltip></el-table-column>
      <el-table-column label="计划" prop="planNumTotal"></el-table-column>
      <el-table-column label="余备料" prop="residueNumTotal"></el-table-column>
      <el-table-column label="未排" prop="unPlanNumTotal"></el-table-column>
      <el-table-column label="排程" prop="planCount"></el-table-column>
      <el-table-column label="在制" prop="makingNumTotal"></el-table-column>
      <el-table-column :label="processLabel" prop="inStockNum"></el-table-column>
      <el-table-column label="在途" prop="passage"></el-table-column>
      <el-table-column label="物流总库存" prop="totalLogistics"></el-table-column>
      <el-table-column label="可销售库存" prop="companyAvlInventory"></el-table-column>
    </el-table>
  </q-dialog>
</template>

<script>
export default {
  name: 'RelatedProductDetail',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    productCode: String,
    productName: String
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    processLabel() {
      const processCode = this.productInfo.processCode || '';
      return `${processCode}报工`;
    }
  },
  data() {
    return {
      productInfo: {},
      tableData1: [],
      tableData2: [],
      loading: false
    }
  },
  methods: {
    getDetail() {
      const params = {
        params: {
          productCode: this.productCode
        }
      };
      this.loading = true;
      this.$q.newProduct.getRelatedProductInfo(params)
          .then(({data}) => {
            if (data) {
              if (data.emallNewProductProductPlanInfoVO) {
                this.productInfo = data.emallNewProductProductPlanInfoVO;
                this.tableData1 = [data.emallNewProductProductPlanInfoVO];
              }
              this.tableData2 = data.emallNewProductPackPlanInfoVO || [];
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onCancel() {
      this.isVisible = false;
    }
  },
  created() {
    this.getDetail();
  }
}
</script>

<style lang="stylus" scoped>
.table-title
  margin-bottom 10px
.mt10
  margin-top 10px

>>> .el-dialog__body{
  height: 70vh
  overflow-y: auto
}
>>> .scorll-wrap {
  height: 100% !important
}
</style>